import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardService } from 'ngx-clipboard';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  AdditionalWorkDetails,
  AppointmentServiceDetails
} from 'projects/Administration/src/app/business-entities/appointment-service-details-view-model';
import { AppointmentDetail } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import { BrandViewModel } from 'projects/Administration/src/app/business-entities/brand-view-model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { AppointmentWorkOrderService } from 'projects/Administration/src/app/business-services/appointment-work-order.service';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as Enums from '../../../../../../../../Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-work-order-history-details',
  templateUrl: './work-order-history-details.component.html',
})
export class WorkOrderHistoryDetailsComponent implements OnInit {
  contactDetails: AppointmentDetail;
  appointmentServiceDetail: AppointmentServiceDetails;
  appointmentDetails: AppointmentDetail;
  brandList: BrandViewModel[];
  features: Features[] = [];
  formattedTotalTime: string;
  appointmentBookedDate: any;
  appointmentCreatedDate: any;
  appointmentUpdatedDate: any;
  appointmentStatusName: string;
  isDwo: boolean = true;
  additionalWorkDetails: AdditionalWorkDetails;
  brandLogoPath: any;
  @Input() woAppoinment: any; //While opening a popUP, we will have a value of this input variable.

  constructor(
    private readonly appointmentService: AppointmentService,
    private readonly spinner: NgxSpinnerService,
    private readonly editAppointmentService: EditAppointmentService,
    private readonly cookieservice: CookieService,
    private readonly activeModal: NgbActiveModal,
    private readonly secureStorage: SecureStorage,
    public workOrderService: AppointmentWorkOrderService,
    public workOrderAdditionalService: AppointmentWorkOrderService,
    private readonly clipboardApi: ClipboardService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.brandLogoPath = this.woAppoinment.brandLogoPath;
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        let feature = this.features.find(
          (x) => x.featureCode === Enums.FeatureCode.DWO
        ).isActive;
        if (feature === false) {
          this.isDwo = false;
        } else {
          this.isDwo = true;
        }
      }
    }
    this.GetAppointmentDetail();
    this.GetServiceDetail();
    this.GetAdditionalWorkDetails();
  }

  //Services
  async GetServiceDetail() {
    await this.appointmentService
      .GetServiceDetail(
        this.editAppointmentService.appointmentIdOfSelectedWO,
        this.editAppointmentService.appointmentGuidOfSelectedWO
      )
      .then((data) => {
        if (data.responseObject?.errorCount > 0) {
          this.appointmentServiceDetail = {
            totalPrice: 0,
            totalTime: 0,
            priceForDisply:'',
            rentalCompanyMakeName:'',
            totalInvoicePrice: 0,
            appointmentDemandList: [],
            appointmentJobDetailList: [],
            appointmentJobList: [],
            appointmentPriceDetails: [],
          };
          this.workOrderService.totalPrice = null;
          this.workOrderService.totalTime = null;
          this.workOrderService.totalInvoicePrice = null;
        } else {
          this.appointmentServiceDetail = data.responseObject;
          this.workOrderService.appointmentDemandList =
            this.appointmentServiceDetail.appointmentDemandList;
          this.workOrderService.appointmentJobList =
            this.appointmentServiceDetail.appointmentJobList;
          this.workOrderService.appointmentJobDetailList =
            this.appointmentServiceDetail.appointmentJobDetailList;
          this.workOrderService.totalPrice = 0;
          this.workOrderService.totalPriceInclVAT = 0;
          this.workOrderService.totalInvoicePrice = 0;
          this.workOrderService.totalTime =
            this.appointmentServiceDetail.totalTime;
          if (this.appointmentServiceDetail.taxDetail) {
            this.workOrderService.taxDetail =
              this.appointmentServiceDetail.taxDetail;
            this.workOrderService.totalPrice =
              this.appointmentServiceDetail.taxDetail.totalPriceInclTAX;
            this.workOrderService.totalInvoicePrice =
              this.appointmentServiceDetail.taxDetail.totalInvoicePrice;
            this.workOrderService.totalPriceInclVAT =
              this.appointmentServiceDetail.taxDetail.salesPriceInclVAT;
          }
          this.formattedTotalTime = Number(
            this.workOrderService.totalTime
          ).toFixed(2);

          this.workOrderService.appointmentJobDetailToUpdate =
            this.appointmentServiceDetail.appointmentJobDetailList.slice();
        }
      });
  }

  //Appointment detail > brand
  getStatusBrand(dealerId: string, appointmentId: number) {
    let languageCode = this.cookieservice.get('userSelectedLanguage');
    this.appointmentService
      .getStatusBrand(dealerId, appointmentId, languageCode)
      .then((res) => {
        this.brandList = res.responseObject.brand;
      });
  }

  //Contact detail
  GetAppointmentDetail(): void {
    let language = this.cookieservice.get('userSelectedLanguage');
    this.appointmentService
      .GetAppointmentDetail(
        this.editAppointmentService.appointmentIdOfSelectedWO,
        language
      )
      .then(
        (result) => {
          if ((result.responseCode === Enums.ErrorCodes.SuccessCode)) {
            this.contactDetails = result.responseObject;
            this.appointmentDetails = result.responseObject;
            this.appointmentBookedDate = this.contactDetails.bookedDateTime
              ? new Date(this.contactDetails.bookedDateTime + 'Z')
              : null;
            this.appointmentCreatedDate = this.contactDetails.createdDateTime
              ? new Date(this.contactDetails.createdDateTime + 'Z')
              : null;
            this.appointmentUpdatedDate = this.contactDetails.updatedDateTime
              ? new Date(this.contactDetails.updatedDateTime + 'Z')
              : null;
            this.editAppointmentService.brandCode =
              result.responseObject.companyMakeCode;
            if (this.contactDetails.pickUpDateTime) {
              this.contactDetails.pickUpDateTime = new Date(
                this.contactDetails.pickUpDateTime + 'Z'
              );
            }
            this.getStatusBrand(
              this.contactDetails.dealerId,
              this.editAppointmentService.appointmentIdOfSelectedWO
            );
            this.cdr.detectChanges();
          } else {
            this.spinner.hide();
          }
          this.spinner.hide();
        },
        (_error) => {
          this.spinner.hide();
        }
      );
  }

  //Additional work along with demands, job and job details
  async GetAdditionalWorkDetails() {
    this.spinner.show();
    await this.appointmentService
      .GetAdditionalWorkDetails(
        this.editAppointmentService.appointmentIdOfSelectedWO
      )
      .then((data) => {
        if (data.responseObject.errorCount > 0) {
          this.additionalWorkDetails = {
            appointmentAdditionalDemandList: [],
            appointmentAdditionalJobDetailList: [],
            appointmentAdditionalJobList: [],
          };
        } else {
          this.additionalWorkDetails = data.responseObject;
        }
      });
    this.spinner.hide();
  }

  //Close popUp
  OnClose() {
    this.editAppointmentService.isFromHistoricalWOTab = false;
    this.activeModal.close({success: false});
  }

  copyTextRegistrationNumber() {
    this.clipboardApi.copyFromContent(this.appointmentDetails.licensePlate);
  }

  copyWorkOrderNumber() {
    this.clipboardApi.copyFromContent(this.appointmentDetails.workOrderNo);
  }
}
